// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__PZt1e","rootCenter":"LoadMoreObserver_rootCenter__DMoF2","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__34bOt"};